export default {
    'Gutter': {
        Mobile : 20,
        Desktop : 40
    },
    'ContentGutter': {
        Mobile : 23,
        Desktop : 33
    },
    'NavHeight': {
        Mobile : 40,
        Desktop : 60
    },
    'paddingBottomSpace': {
        Mobile : 43,
        Desktop : 49
    },
    'MaxWidthText': 785
}


// WEBPACK FOOTER //
// ./src/Constants/spacing.ts